import Request from "../lib/request";

const baseUrl = process.env.REACT_APP_API_URL;

export const init = () => {
  return Request({
    method: "get",
    url: baseUrl + "/projects",
    needToken: true
  });
};

export const store = data => {
  return Request({
    method: "post",
    url: baseUrl + "/projects",
    needToken: true,
    data:data
  });
};

export const _delete = id => {
	return Request({
		method: 'delete',
		url: `${baseUrl}/projects/${id}`,
		needToken: true
	});
};

export const edit = (data, project_id) => {
	return Request({
		method: 'put',
		url: `${baseUrl}/projects/${project_id}`,
		needToken: true,
		data
	});
};

export const accept = id=>{
    return Request({
        method: 'get',
        url: `${baseUrl}/acceptInvitation/${id}`,
        needToken: true
    })
};

export const reject = id=>{
    return Request({
        method: 'get',
        url: `${baseUrl}/rejectInvitation/${id}`,
        needToken: true
    })
};

export const archive = (id, data) => {
    return Request({
        method: 'post',
        url: `${baseUrl}/projects/${id}/archive`,
        needToken: true,
        data:data
    });
};

export const getUsersList = () => {
    const projectId = localStorage.getItem("project_id");
    return Request({
        method: "get",
        url: baseUrl + "/projects/" + projectId + "/userList",
        needToken: true,
    });
};